import React, { useEffect, useState } from 'react';
import { IonButton, IonButtons, IonCardContent, IonCol, IonContent, IonGrid, IonHeader, IonMenuButton, IonPage, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import { Card } from '@tremor/react';
import { connect, useSelector } from 'react-redux';
import { UNIFORM_RESOURCE_LOCATORS, colorTheme } from '../../utils/constants';
import { useHistory } from 'react-router';

import { fetchUser } from '../../redux/actions';

const mapStateToProps = state => {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
    fetchUser
}

const UserAccount = ({ fetchUser, user }) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [userName, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const history = useHistory();

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);

    useEffect(() => {
        if (user) {
            setFirstName(user.firstName);
            setLastName(user.lastName);
            setUserName(user.username);
            setEmail(user.email);
        }
    }, [user]);

    const handleChangePassword = () => {
        history.push(UNIFORM_RESOURCE_LOCATORS.changePassword);
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>Account Information</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                {/* START Content */}
                <IonRow>
                    <IonCol size="12">
                        <Card>
                            <div className="d-flex mb-3">
                                <IonTitle size="large">Account Details</IonTitle>
                            </div>
                            <div className='mx-3'>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <h5 style={{ marginRight: '10px', fontSize: '1rem' }}>Username: {userName}</h5>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <h5 style={{ marginRight: '10px', fontSize: '1rem' }}>First Name: {firstName}</h5>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <h5 style={{ marginRight: '10px', fontSize: '1rem' }}>Last Name: {lastName}</h5>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <h5 style={{ marginRight: '10px', fontSize: '1rem' }}>Email: {email}</h5>
                                </div>
                            </div>
                        </Card>
                        <Card className="my-4">
                            <div className="d-flex mb-3">
                                <IonTitle size="large">Password</IonTitle>
                            </div>
                            <div className='mx-3'>
                                <p style={{ margin: '0', fontSize: '1rem' }}>A secure password helps protect your Bomahut Account.</p>
                            </div>
                            <div style={{ padding: '16px' }}>
                                <IonButton
                                    expand="full"
                                    className="shadow"
                                    style={{ backgroundColor: colorTheme["primary"]["700"] }}
                                    onClick={handleChangePassword}
                                >
                                    Change Password
                                </IonButton>
                            </div>
                        </Card>
                    </IonCol>
                </IonRow>
            </IonContent>
        </IonPage>
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserAccount);
